(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class UheatBenefitsCarousel extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('.uheat-benefit'));
      this.dots = Array.from(this.querySelectorAll('.uheat-benefits__dot'));
      this.currentIndex = 0;
      this.timer = null;
      this.resumeTimer = null;
      this.pointerStartX = null;
      this.mobileMedia = window.matchMedia('(max-width: 989px)');
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.interval = Number(this.dataset.interval) || 4000;

      this.handleDotClick = (event) => {
        const index = Number(event.currentTarget.dataset.slide);
        this.show(index);
        this.pauseAfterInteraction();
      };
      this.handlePointerDown = (event) => {
        this.pointerStartX = event.clientX;
      };
      this.handlePointerUp = (event) => {
        if (this.pointerStartX === null) return;
        const distance = event.clientX - this.pointerStartX;
        this.pointerStartX = null;
        if (Math.abs(distance) < 40) return;
        this.show(this.currentIndex + (distance < 0 ? 1 : -1));
        this.pauseAfterInteraction();
      };
      this.handleModeChange = () => {
        this.show(this.currentIndex);
        this.start();
      };
      this.handleVisibility = () => {
        if (document.hidden) this.stop();
        else this.start();
      };

      this.dots.forEach((dot) => dot.addEventListener('click', this.handleDotClick));
      this.addEventListener('pointerdown', this.handlePointerDown);
      this.addEventListener('pointerup', this.handlePointerUp);
      this.mobileMedia.addEventListener('change', this.handleModeChange);
      this.reducedMotion.addEventListener('change', this.handleModeChange);
      document.addEventListener('visibilitychange', this.handleVisibility);

      this.show(0);
      this.start();
    }

    disconnectedCallback() {
      this.stop();
      window.clearTimeout(this.resumeTimer);
      this.dots?.forEach((dot) => dot.removeEventListener('click', this.handleDotClick));
      this.removeEventListener('pointerdown', this.handlePointerDown);
      this.removeEventListener('pointerup', this.handlePointerUp);
      this.mobileMedia?.removeEventListener('change', this.handleModeChange);
      this.reducedMotion?.removeEventListener('change', this.handleModeChange);
      document.removeEventListener('visibilitychange', this.handleVisibility);
    }

    show(index) {
      if (!this.items.length) return;
      this.currentIndex = (index + this.items.length) % this.items.length;
      const isMobile = this.mobileMedia.matches;

      this.items.forEach((item, itemIndex) => {
        const active = itemIndex === this.currentIndex;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-hidden', isMobile && !active ? 'true' : 'false');
      });

      this.dots.forEach((dot, dotIndex) => {
        const active = dotIndex === this.currentIndex;
        dot.classList.toggle('is-active', active);
        if (active) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    }

    start() {
      this.stop();
      if (!this.mobileMedia.matches || this.reducedMotion.matches || document.hidden || this.offsetParent === null) return;
      this.timer = window.setInterval(() => this.show(this.currentIndex + 1), this.interval);
    }

    stop() {
      if (this.timer) window.clearInterval(this.timer);
      this.timer = null;
    }

    pauseAfterInteraction() {
      this.stop();
      window.clearTimeout(this.resumeTimer);
      if (this.reducedMotion.matches) return;
      this.resumeTimer = window.setTimeout(() => this.start(), 8000);
    }
  }

  if (!customElements.get('uheat-benefits-carousel')) {
    customElements.define('uheat-benefits-carousel', UheatBenefitsCarousel);
  }

  class UheatAdviceDisclosure extends HTMLElement {

    static holidayDates = {"england-and-wales":["2026-01-01","2026-04-03","2026-04-06","2026-05-04","2026-05-25","2026-08-31","2026-12-25","2026-12-28","2027-01-01","2027-03-26","2027-03-29","2027-05-03","2027-05-31","2027-08-30","2027-12-27","2027-12-28","2028-01-03","2028-04-14","2028-04-17","2028-05-01","2028-05-29","2028-08-28","2028-12-25","2028-12-26"],"scotland":["2026-01-01","2026-01-02","2026-04-03","2026-05-04","2026-05-25","2026-06-15","2026-08-03","2026-11-30","2026-12-25","2026-12-28","2027-01-01","2027-01-04","2027-03-26","2027-05-03","2027-05-31","2027-08-02","2027-11-30","2027-12-27","2027-12-28","2028-01-03","2028-01-04","2028-04-14","2028-05-01","2028-05-29","2028-08-07","2028-11-30","2028-12-25","2028-12-26"],"northern-ireland":["2026-01-01","2026-03-17","2026-04-03","2026-04-06","2026-05-04","2026-05-25","2026-07-13","2026-08-31","2026-12-25","2026-12-28","2027-01-01","2027-03-17","2027-03-26","2027-03-29","2027-05-03","2027-05-31","2027-07-12","2027-08-30","2027-12-27","2027-12-28","2028-01-03","2028-03-17","2028-04-14","2028-04-17","2028-05-01","2028-05-29","2028-07-12","2028-08-28","2028-12-25","2028-12-26"]};
    static holidayRefreshPromise = null;
    static nextHolidayRefresh = 0;

    static validHolidayDates(dates) {
      return ['england-and-wales', 'scotland', 'northern-ireland'].every((region) =>
        Array.isArray(dates?.[region]) &&
        dates[region].length >= 5 &&
        dates[region].every((date) => typeof date === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(date))
      );
    }

    static refreshHolidayCalendar() {
      if (this.holidayRefreshPromise) return this.holidayRefreshPromise;
      if (Date.now() < this.nextHolidayRefresh) return Promise.resolve();

      try {
        const cached = JSON.parse(localStorage.getItem('uheat-advice-bank-holidays-v1') || 'null');
        if (cached && this.validHolidayDates(cached.dates) &&
            Number.isFinite(cached.updatedAt) && cached.updatedAt <= Date.now() &&
            Date.now() - cached.updatedAt < 21600000) {
          this.holidayDates = cached.dates;
          this.nextHolidayRefresh = cached.updatedAt + 21600000;
          return Promise.resolve();
        }
      } catch (_error) {}

      this.nextHolidayRefresh = Date.now() + 300000;
      const controller = new AbortController();
      const timeout = window.setTimeout(() => controller.abort(), 5000);
      this.holidayRefreshPromise = fetch('https://www.gov.uk/bank-holidays.json', {
        signal: controller.signal,
        credentials: 'omit',
        referrerPolicy: 'no-referrer',
      })
        .then((response) => {
          if (!response.ok) throw new Error('Holiday calendar unavailable');
          return response.json();
        })
        .then((calendar) => {
          const dates = Object.fromEntries(
            ['england-and-wales', 'scotland', 'northern-ireland'].map((region) => [
              region,
              (calendar[region]?.events || []).map((event) => event.date),
            ])
          );
          if (!this.validHolidayDates(dates)) throw new Error('Invalid holiday calendar');
          const year = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', year: 'numeric' }).format(new Date());
          if (!Object.values(dates).every((entries) => entries.filter((date) => date.startsWith(year + '-')).length >= 5)) {
            throw new Error('Holiday calendar is out of date');
          }
          this.holidayDates = dates;
          const updatedAt = Date.now();
          this.nextHolidayRefresh = updatedAt + 21600000;
          try {
            localStorage.setItem('uheat-advice-bank-holidays-v1', JSON.stringify({ dates, updatedAt }));
          } catch (_error) {}
        })
        .catch(() => {})
        .finally(() => {
          window.clearTimeout(timeout);
          this.holidayRefreshPromise = null;
        });
      return this.holidayRefreshPromise;
    }

    refreshBankHolidays() {
      UheatAdviceDisclosure.refreshHolidayCalendar().then(() => {
        if (this.isConnected) this.updateAvailability();
      });
    }

    connectedCallback() {
      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.status = this.querySelector('[data-advice-status]');
      this.statusText = this.querySelector('[data-advice-status-text]');
      this.handleOutsideClick = (event) => {
        if (this.details?.open && !this.contains(event.target)) this.details.open = false;
      };
      this.handleEscape = (event) => {
        if (event.key !== 'Escape' || !this.details?.open) return;
        this.details.open = false;
        this.summary?.focus();
      };
      document.addEventListener('pointerdown', this.handleOutsideClick);
      this.addEventListener('keydown', this.handleEscape);
      this.updateAvailability();
      this.refreshBankHolidays();
      this.availabilityTimer = window.setInterval(() => {
        this.updateAvailability();
        this.refreshBankHolidays();
      }, 60000);
      this.handleVisibility = () => {
        if (document.visibilityState === 'visible') {
          this.updateAvailability();
          this.refreshBankHolidays();
        }
      };
      document.addEventListener('visibilitychange', this.handleVisibility);
    }

    disconnectedCallback() {
      document.removeEventListener('pointerdown', this.handleOutsideClick);
      this.removeEventListener('keydown', this.handleEscape);
      window.clearInterval(this.availabilityTimer);
      document.removeEventListener('visibilitychange', this.handleVisibility);
    }

    timeToMinutes(value) {
      if (!/^\d{2}:\d{2}$/.test(value || '')) return null;
      const [hour, minute] = value.split(':').map(Number);
      if (hour > 23 || minute > 59) return null;
      return hour * 60 + minute;
    }

    updateAvailability(date = new Date()) {
      if (!this.status || !this.statusText) return;

      let parts;
      try {
        parts = new Intl.DateTimeFormat('en-GB', {
          timeZone: this.dataset.timeZone || 'Europe/London',
          weekday: 'short',
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          hourCycle: 'h23',
        }).formatToParts(date);
      } catch (_error) {
        return;
      }

      const current = Object.fromEntries(parts.filter((part) => part.type !== 'literal').map((part) => [part.type, part.value]));
      const dateKey = `${current.year}-${current.month}-${current.day}`;
      const closureDates = (this.dataset.bankHolidays || '')
        .split(/[\s,;]+/)
        .map((date) => date.trim())
        .filter(Boolean);

      const region = this.dataset.holidayRegion || 'england-and-wales';
      const bankHolidays = UheatAdviceDisclosure.holidayDates[region] || [];
      const calendarCoversYear = bankHolidays.filter((holiday) => holiday.startsWith(current.year + '-')).length >= 5;
      const isBankHoliday = bankHolidays.includes(dateKey);

      let openingTime = '';
      let closingTime = '';
      if (['Mon', 'Tue', 'Wed', 'Thu', 'Fri'].includes(current.weekday)) {
        openingTime = this.dataset.weekdayOpen;
        closingTime = this.dataset.weekdayClose;
      } else if (current.weekday === 'Sat') {
        openingTime = this.dataset.saturdayOpen;
        closingTime = this.dataset.saturdayClose;
      } else if (current.weekday === 'Sun') {
        openingTime = this.dataset.sundayOpen;
        closingTime = this.dataset.sundayClose;
      }

      const opensAt = this.timeToMinutes(openingTime);
      const closesAt = this.timeToMinutes(closingTime);
      const now = Number(current.hour) * 60 + Number(current.minute);
      const isOpen = calendarCoversYear && !isBankHoliday && !closureDates.includes(dateKey) && opensAt !== null && closesAt !== null && now >= opensAt && now < closesAt;

      this.status.classList.toggle('is-open', isOpen);
      this.statusText.textContent = isOpen ? this.dataset.openMessage : this.dataset.closedMessage;
    }
  }

  if (!customElements.get('uheat-advice-disclosure')) {
    customElements.define('uheat-advice-disclosure', UheatAdviceDisclosure);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["interactive-underfloor-heating-selector"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('underfloor-heating-quiz')) {
    class UnderfloorHeatingQuiz extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.screens = Array.from(this.querySelectorAll('[data-screen]'));
        this.progress = this.querySelector('[data-progress]');
        this.progressBar = this.querySelector('[data-progress-bar]');
        this.progressCopy = this.querySelector('[data-progress-copy]');
        this.backButton = this.querySelector('[data-action="back"]');
        this.resetButton = this.querySelector('[data-action="reset"]');
        this.summary = this.querySelector('[data-summary]');
        this.calculatorContext = this.querySelector('[data-calculator-context]');
        this.calculatorAreaTarget = this.querySelector('[data-calculator-area]');
        this.resultsGrid = this.querySelector('[data-results-grid]');
        this.resultsHeading = this.querySelector('[data-results-heading]');
        this.resultFootnote = this.querySelector('[data-result-footnote]');
        this.quoteButton = this.querySelector('[data-quote-button]');
        this.currentScreen = 'chooser';
        this.currentSystem = '';
        this.selections = [];
        this.history = [];
        this.addEventListener('click', this.handleClick.bind(this));
        this.updateProgress(1);
        this.applyCalculatorContext();
      }

      applyCalculatorContext() {
        const params = new URLSearchParams(window.location.search);
        const area = Number.parseFloat(params.get('heated_area') || '');
        if (!Number.isFinite(area) || area <= 0 || area > 10000) return;
        this.calculatorArea = area;
        this.calculatorSystemType = params.get('system_type') || '';
        if (this.calculatorContext && this.calculatorAreaTarget) {
          this.calculatorAreaTarget.textContent = `${area.toFixed(2)} m²`;
          this.calculatorContext.hidden = false;
        }
        this.updateSummary();

        if (this.calculatorSystemType === 'water') {
          this.currentSystem = 'water';
          this.dataset.system = 'water';
          this.selections = [this.dataset.waterHeading || 'Water underfloor heating'];
          this.history.push({ screen: 'chooser', system: '', selections: [] });
          this.updateSummary();
          this.showQuestion('water-stage');
        } else if (this.calculatorSystemType === 'electric-mat' || this.calculatorSystemType === 'electric-cable') {
          this.currentSystem = 'electric';
          this.dataset.system = 'electric';
          this.selections = [this.dataset.electricHeading || 'Electric underfloor heating'];
          this.history.push({ screen: 'chooser', system: '', selections: [] });
          this.updateSummary();
          this.showQuestion('electric-floor');
        }
      }

      handleClick(event) {
        const choice = event.target.closest('[data-system-choice], .uh-quiz__answer[data-next], .uh-quiz__answer[data-results]');
        if (choice && this.contains(choice)) {
          this.choose(choice);
          return;
        }
        const action = event.target.closest('[data-action]');
        if (!action || !this.contains(action)) return;
        if (action.dataset.action === 'back') this.goBack();
        if (action.dataset.action === 'reset') this.resetQuiz();
      }

      choose(choice) {
        this.history.push({
          screen: this.currentScreen,
          system: this.currentSystem,
          selections: [...this.selections]
        });
        if (choice.dataset.systemChoice) {
          this.currentSystem = choice.dataset.systemChoice;
          this.dataset.system = this.currentSystem;
        }
        const label = choice.dataset.answerLabel || choice.textContent.trim();
        this.selections.push(label);
        this.updateSummary();
        if (choice.dataset.results) {
          this.showResults(choice.dataset.results.split(','), choice.dataset.showFootnote === 'true');
        } else if (choice.dataset.next) {
          this.showQuestion(choice.dataset.next);
        }
      }

      showQuestion(questionId) {
        const screen = this.querySelector(`[data-question-id="${questionId}"]`);
        if (!screen) return;
        this.currentScreen = questionId;
        this.showScreen(screen);
        this.updateProgress(Number(screen.dataset.step || 1));
      }

      showResults(systems, showFootnote) {
        const screen = this.querySelector('[data-screen="results"]');
        this.currentScreen = 'results';
        this.resultsGrid.replaceChildren();
        systems.forEach((system) => {
          const source = this.querySelector(`.uh-quiz__system-source[data-system="${system}"]`);
          const card = source?.querySelector('.uh-quiz__result-card')?.cloneNode(true);
          if (card) {
            card.querySelectorAll('a[href]').forEach((link) => this.appendCalculatorContext(link));
            this.resultsGrid.appendChild(card);
          } else {
            const fallback = document.createElement('article');
            fallback.className = 'uh-quiz__result-card';
            const title = document.createElement('h4');
            title.textContent = this.systemTitle(system);
            fallback.appendChild(title);
            this.resultsGrid.appendChild(fallback);
          }
        });
        this.resultsHeading.textContent = this.dataset.resultHeading || 'Recommended systems';
        this.resultFootnote.hidden = !showFootnote;
        this.querySelector('[data-overlay-guidance]').hidden = !systems.some((system) => ['ad-cxps', 'ad-eps400', 'ad-slim'].includes(system));
        const quoteUrl = this.dataset.quoteUrl;
        if (quoteUrl) {
          this.quoteButton.href = quoteUrl;
          this.appendCalculatorContext(this.quoteButton);
          this.quoteButton.textContent = this.dataset.quoteLabel || 'Request a quote';
          this.quoteButton.hidden = false;
        } else {
          this.quoteButton.hidden = true;
        }
        this.showScreen(screen);
        this.updateProgress(4, true);
      }

      showScreen(target) {
        this.screens.forEach((screen) => {
          screen.hidden = screen !== target;
        });
        this.updateNavigation();
        requestAnimationFrame(() => {
          target.querySelector('h3')?.focus({ preventScroll: true });
          if (window.matchMedia('(max-width: 749px)').matches) {
            target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'nearest' });
          }
        });
      }

      goBack() {
        const previous = this.history.pop();
        if (!previous) return;
        this.currentSystem = previous.system;
        this.selections = [...previous.selections];
        if (this.currentSystem) {
          this.dataset.system = this.currentSystem;
        } else {
          this.removeAttribute('data-system');
        }
        this.updateSummary();
        this.currentScreen = previous.screen;
        if (previous.screen === 'chooser') {
          this.showScreen(this.querySelector('[data-screen="chooser"]'));
          this.updateProgress(1);
        } else {
          const screen = this.querySelector(`[data-question-id="${previous.screen}"]`);
          this.showScreen(screen);
          this.updateProgress(Number(screen.dataset.step || 1));
        }
      }

      resetQuiz() {
        this.currentScreen = 'chooser';
        this.currentSystem = '';
        this.selections = [];
        this.history = [];
        this.removeAttribute('data-system');
        this.resultsGrid.replaceChildren();
        this.resultFootnote.hidden = true;
        this.quoteButton.hidden = true;
        this.updateSummary();
        this.showScreen(this.querySelector('[data-screen="chooser"]'));
        this.updateProgress(1);
      }

      updateSummary() {
        this.summary.replaceChildren();
        if (this.selections.length > 0 || this.calculatorArea) {
          const label = document.createElement('span');
          label.className = 'uh-quiz__summary-label';
          label.textContent = this.dataset.summaryLabel || 'Your project';
          this.summary.appendChild(label);
        }
        this.selections.forEach((selection) => {
          const chip = document.createElement('span');
          chip.className = 'uh-quiz__summary-chip';
          chip.textContent = selection;
          this.summary.appendChild(chip);
        });
        if (this.calculatorArea) {
          const areaChip = document.createElement('span');
          areaChip.className = 'uh-quiz__summary-chip';
          areaChip.textContent = `Heated area: ${this.calculatorArea.toFixed(2)} m²`;
          this.summary.appendChild(areaChip);
        }
        this.summary.hidden = this.selections.length === 0 && !this.calculatorArea;
      }

      appendCalculatorContext(link) {
        if (!this.calculatorArea || !link?.href) return;
        const url = new URL(link.href, window.location.origin);
        url.searchParams.set('heated_area', this.calculatorArea.toFixed(2));
        url.searchParams.set('area_source', 'room-calculator');
        link.href = url.toString();
      }

      updateProgress(step, complete = false) {
        const safeStep = Math.max(1, Math.min(4, step));
        this.progress.setAttribute('aria-valuenow', String(safeStep));
        this.progressBar.style.width = `${safeStep * 25}%`;
        this.progressCopy.textContent = complete
          ? (this.dataset.completeLabel || 'Complete')
          : `${this.dataset.stepPrefix || 'Step'} ${safeStep} of 4`;
      }

      updateNavigation() {
        const disabled = this.history.length === 0;
        this.backButton.disabled = disabled;
        this.resetButton.disabled = disabled;
      }

      systemTitle(system) {
        const titles = {
          vcd17: 'VCD 17',
          md: 'MD',
          ultratec: 'UltraTec',
          heatbase: 'HeatBase',
          woodtec: 'WoodTec',
          floortec: 'FloorTec',
          'ad-plate': 'AD•PLATE',
          'ad-dry': 'AD•DRY',
          'ad-tray': 'AD•TRAY',
          'ad-clip': 'AD•CLIP',
          'ad-rail': 'AD•RAIL',
          'ad-cxps': 'AD-CXPS',
          'ad-eps400': 'AD-EPS400',
          'ad-slim': 'AD-SLIM',
          'ad-slim-lite': 'AD•SLIM-LITE',
          'ad-slim-max': 'AD•SLIM-MAX'
        };
        return titles[system] || system;
      }
    }

    customElements.define('underfloor-heating-quiz', UnderfloorHeatingQuiz);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uheat-all-solutions"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('uheat-solution-finder')) {
    customElements.define('uheat-solution-finder', class extends HTMLElement {
      connectedCallback() {
        this.typeButtons = Array.from(this.querySelectorAll('[data-heating-type]'));
        this.questionPanels = Array.from(this.querySelectorAll('[data-question]'));
        this.resultPanels = Array.from(this.querySelectorAll('[data-result]'));
        this.resetButton = this.querySelector('[data-reset-finder]');
        this.currentType = 'electric';
        this.typeButtons.forEach((button) => button.addEventListener('click', () => this.selectType(button.dataset.heatingType)));
        this.querySelectorAll('[data-next-question]').forEach((button) => button.addEventListener('click', () => this.showQuestion(button.dataset.nextQuestion)));
        this.querySelectorAll('[data-back-question]').forEach((button) => button.addEventListener('click', () => this.showQuestion(button.dataset.backQuestion)));
        this.querySelectorAll('[data-result-choice]').forEach((button) => button.addEventListener('click', () => this.showResult(button)));
        if (this.resetButton) this.resetButton.addEventListener('click', () => this.selectType(this.currentType));
      }

      selectType(type) {
        this.currentType = type;
        this.typeButtons.forEach((button) => {
          const active = button.dataset.heatingType === type;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        const firstQuestion = type === 'frost' ? 'frost-start' : `${type}-start`;
        this.showQuestion(firstQuestion);
        this.showResultPanel('placeholder');
        if (this.resetButton) this.resetButton.hidden = true;
      }

      showQuestion(name) {
        this.questionPanels.forEach((panel) => { panel.hidden = panel.dataset.question !== name; });
        this.querySelectorAll('.uas-choice').forEach((choice) => choice.classList.remove('is-selected'));
        this.showResultPanel('placeholder');
        if (this.resetButton) this.resetButton.hidden = true;
      }

      showResult(button) {
        this.querySelectorAll('.uas-choice').forEach((choice) => choice.classList.remove('is-selected'));
        button.classList.add('is-selected');
        this.showResultPanel(button.dataset.resultChoice);
        if (this.resetButton) this.resetButton.hidden = false;
      }

      showResultPanel(name) {
        this.resultPanels.forEach((panel) => { panel.hidden = panel.dataset.result !== name; });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uheat-default-collection-hero"] && !Shopify.designMode) return;
  try {
    
  function initMobileCollectionDescriptions(root = document) {
    root.querySelectorAll('[data-mobile-description]').forEach((wrapper) => {
      if (wrapper.dataset.descriptionReady) return;
      wrapper.dataset.descriptionReady = 'true';
      const description = wrapper.querySelector('.uheat-default-collection-hero__description');
      const toggle = wrapper.querySelector('.uheat-default-collection-hero__description-toggle');
      if (!description || !toggle) return;

      const update = () => {
        if (!window.matchMedia('(max-width: 749px)').matches) {
          toggle.hidden = true;
          return;
        }
        if (!wrapper.classList.contains('is-expanded')) {
          toggle.hidden = description.scrollHeight <= description.clientHeight + 2;
        }
      };

      toggle.addEventListener('click', () => {
        const expanded = wrapper.classList.toggle('is-expanded');
        toggle.setAttribute('aria-expanded', String(expanded));
        update();
      });
      window.addEventListener('resize', update);
      update();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initMobileCollectionDescriptions(), { once: true });
  } else {
    initMobileCollectionDescriptions();
  }
  document.addEventListener('shopify:section:load', (event) => initMobileCollectionDescriptions(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uheat-download-library"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('uheat-download-library')) {
    customElements.define(
      'uheat-download-library',
      class UheatDownloadLibrary extends HTMLElement {
        connectedCallback() {
          if (this.initialised) return;
          this.initialised = true;
          this.grid = this.querySelector('[data-download-grid]');
          this.input = this.querySelector('[data-download-search-input]');
          this.clearButton = this.querySelector('[data-download-clear]');
          this.status = this.querySelector('[data-download-status]');
          this.emptyState = this.querySelector('[data-download-empty]');
          this.noResultsState = this.querySelector('[data-download-no-results]');
          this.cards = new Map();
          this.loading = true;
          this.abortController = new AbortController();

          this.querySelectorAll('[data-download-card]').forEach((card) => this.registerCard(card));
          this.input?.addEventListener('input', () => this.filterCards());
          this.clearButton?.addEventListener('click', () => {
            this.input.value = '';
            this.input.focus();
            this.filterCards();
          });

          this.loadRemainingPages();
        }

        disconnectedCallback() {
          this.abortController?.abort();
        }

        normalise(value) {
          return (value || '')
            .toLocaleLowerCase()
            .normalize('NFKD')
            .replace(/[\u0300-\u036f]/g, ' ')
            .replace(/[^a-z0-9]+/g, ' ')
            .trim();
        }

        registerCard(card, append = false) {
          const identity = card.dataset.downloadId || card.querySelector('.uheat-download-card__action')?.href;
          if (!identity) return;

          const existing = this.cards.get(identity);
          if (existing) {
            existing.dataset.downloadSearch = `${existing.dataset.downloadSearch || ''} ${card.dataset.downloadSearch || ''}`;
            const products = existing.querySelector('[data-download-products]');
            const productKeys = new Set(
              [...products.querySelectorAll('[data-download-product]')].map((link) => link.dataset.productKey)
            );
            card.querySelectorAll('[data-download-product]').forEach((link) => {
              if (!productKeys.has(link.dataset.productKey)) {
                products.append(link.cloneNode(true));
                productKeys.add(link.dataset.productKey);
              }
            });
            card.remove();
            return;
          }

          this.cards.set(identity, card);
          if (append) this.grid.append(card);
          this.applyCurrentQuery(card);
        }

        applyCurrentQuery(card) {
          const query = this.normalise(this.input?.value);
          const terms = query.split(' ').filter(Boolean);
          const searchable = this.normalise(card.dataset.downloadSearch);
          card.hidden = terms.length > 0 && !terms.every((term) => searchable.includes(term));
          return !card.hidden;
        }

        filterCards() {
          let visibleCount = 0;
          this.cards.forEach((card) => {
            if (this.applyCurrentQuery(card)) visibleCount += 1;
          });

          const hasQuery = Boolean(this.normalise(this.input?.value));
          if (this.clearButton) this.clearButton.hidden = !hasQuery;
          if (this.noResultsState) this.noResultsState.hidden = this.loading || !hasQuery || visibleCount > 0;
          if (this.emptyState) this.emptyState.hidden = this.loading || this.cards.size > 0;

          if (!this.loading) this.updateStatus(hasQuery ? visibleCount : this.cards.size, hasQuery);
        }

        updateStatus(count, isSearch = false) {
          if (!this.status) return;
          const suffix = count === 1 ? 'One' : 'Other';
          const label = isSearch
            ? this.dataset[`found${suffix}`]
            : this.dataset[`available${suffix}`];
          this.status.textContent = (label || '').replace('{count}', count);
        }

        sortCards() {
          [...this.cards.values()]
            .sort((first, second) =>
              (first.dataset.downloadTitle || '').localeCompare(second.dataset.downloadTitle || '', undefined, {
                numeric: true,
                sensitivity: 'base',
              })
            )
            .forEach((card) => this.grid.append(card));
        }

        async fetchPage(page) {
          const url = new URL(window.location.href);
          url.searchParams.set('page', String(page));
          url.searchParams.set('section_id', this.dataset.sectionId);

          const response = await fetch(url.toString(), {
            credentials: 'same-origin',
            signal: this.abortController.signal,
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
          });
          if (!response.ok) throw new Error(`Unable to load downloads page ${page}`);

          const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
          return [...documentFragment.querySelectorAll('[data-download-card]')];
        }

        async loadRemainingPages() {
          const totalPages = Number.parseInt(this.dataset.totalPages || '1', 10);
          const currentPage = Number.parseInt(this.dataset.currentPage || '1', 10);
          const pages = Array.from({ length: totalPages }, (_, index) => index + 1).filter(
            (page) => page !== currentPage
          );

          const results = await Promise.allSettled(pages.map((page) => this.fetchPage(page)));
          if (this.abortController.signal.aborted) return;

          let loadFailed = false;
          results.forEach((result) => {
            if (result.status === 'rejected') {
              loadFailed = true;
              return;
            }
            result.value.forEach((card) => this.registerCard(card, true));
          });

          this.loading = false;
          this.sortCards();
          this.filterCards();
          if (loadFailed && this.status) this.status.textContent = this.dataset.loadErrorLabel;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uheat-guides-hub"] && !Shopify.designMode) return;
  try {
    
  const initialiseGuideFilters = (section) => {
    if (section.dataset.filtersReady === 'true') return;

    const buttons = section.querySelectorAll('[data-guide-filter]');
    const cards = section.querySelectorAll('[data-guide-topic]');
    if (!buttons.length || !cards.length) return;

    section.dataset.filtersReady = 'true';

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const selectedTopic = button.dataset.guideFilter;

        buttons.forEach((item) => {
          const isSelected = item === button;
          item.classList.toggle('is-active', isSelected);
          item.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
        });

        cards.forEach((card) => {
          card.hidden = selectedTopic !== 'all' && card.dataset.guideTopic !== selectedTopic;
        });
      });
    });
  };

  document.querySelectorAll('.uheat-guides-hub').forEach(initialiseGuideFilters);

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('.uheat-guides-hub');
    if (section) initialiseGuideFilters(section);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uheat-related-collections"] && !Shopify.designMode) return;
  try {
    
  class UheatCategoryDirectory extends HTMLElement {
    connectedCallback() {
      this.toggleButton = this.querySelector('[data-category-toggle]');
      if (!this.toggleButton) return;

      this.classList.add('is-enhanced');
      this.handleToggle = () => {
        const expanded = this.getAttribute('data-expanded') === 'true';
        this.setAttribute('data-expanded', String(!expanded));
        this.toggleButton.setAttribute('aria-expanded', String(!expanded));
      };

      this.toggleButton.addEventListener('click', this.handleToggle);
    }

    disconnectedCallback() {
      this.toggleButton?.removeEventListener('click', this.handleToggle);
    }
  }

  if (!customElements.get('uheat-category-directory')) {
    customElements.define('uheat-category-directory', UheatCategoryDirectory);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uheat-trade-installers"] && !Shopify.designMode) return;
  try {
    
  // Keep the external form's fixed-width verification control inside narrow phones.
  function fitTradeForms() {
    document.querySelectorAll('.uheat-trade-first__jotform').forEach((container) => {
      if (container.dataset.mobileFitReady) return;
      container.dataset.mobileFitReady = 'true';
      const fit = () => {
        const frame = container.querySelector('iframe');
        if (!frame) return;
        const available = container.clientWidth;
        const width = Math.max(340, available);
        const scale = Math.min(1, available / width);
        container.style.setProperty('--utf-form-width', width + 'px');
        container.style.setProperty('--utf-form-scale', scale);
        container.style.setProperty('--utf-form-height', Math.ceil(frame.offsetHeight * scale) + 'px');
      };
      const resize = new ResizeObserver(fit);
      resize.observe(container);
      const observeFrame = () => {
        const frame = container.querySelector('iframe');
        if (frame && !frame.dataset.mobileFitObserved) {
          frame.dataset.mobileFitObserved = 'true';
          resize.observe(frame);
          frame.addEventListener('load', fit);
        }
        fit();
      };
      new MutationObserver(observeFrame).observe(container, { childList: true });
      observeFrame();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fitTradeForms);
  else fitTradeForms();
  document.addEventListener('shopify:section:load', fitTradeForms);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uheat-water-guide-portal"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('water-guide-directory')) {
    customElements.define('water-guide-directory', class extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('[data-guide-search]');
        this.cards = Array.from(this.querySelectorAll('[data-guide-card]'));
        this.groups = Array.from(this.querySelectorAll('[data-guide-group]'));
        this.status = this.querySelector('[data-guide-status]');
        this.empty = this.querySelector('[data-guide-empty]');
        this.filter = () => {
          const terms = this.input.value.trim().toLocaleLowerCase().split(/\s+/).filter(Boolean);
          let count = 0;
          this.cards.forEach(card => {
            const text = card.textContent.toLocaleLowerCase();
            card.hidden = !terms.every(term => text.includes(term));
            if (!card.hidden) count += 1;
          });
          this.groups.forEach(group => { group.hidden = !Array.from(group.querySelectorAll('[data-guide-card]')).some(card => !card.hidden); });
          this.empty.hidden = count > 0;
          this.status.textContent = terms.length ? count + ' ' + (count === 1 ? 'guide found' : 'guides found') : '';
        };
        this.input.addEventListener('input', this.filter);
        this.filter();
      }
      disconnectedCallback() { this.input?.removeEventListener('input', this.filter); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uheat-water-tower-case-study"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    const play = event.target.closest('.water-tower-project__play');
    if (!play) return;
    const videoId = play.dataset.videoId;
    if (!/^[A-Za-z0-9_-]{11}$/.test(videoId)) return;
    const frame = document.createElement('iframe');
    frame.src = 'https://www.youtube-nocookie.com/embed/' + videoId + '?autoplay=1&rel=0';
    frame.title = "Robert Hunt's water tower conversion showcase";
    frame.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
    frame.allowFullscreen = true;
    play.replaceWith(frame);
  });

  } catch(e) { console.error(e); }
})();
})();
